import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

const SURAASA_COLORS = {
  primary: '#315EFB', // Suraasa Blue
  carbon: '#343B4C',
  lightCarbon: '#7D7D7D',
  pearlGray: '#C6CAD8',
  aluminium: '#EEF2F4',

  red: '#FF564E',
  green: '#28BC00',
  yellow: '#FFC000',
}

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: SURAASA_COLORS.primary,
        secondary: SURAASA_COLORS.aluminium,

        success: SURAASA_COLORS.green,
        error: SURAASA_COLORS.red,
        warning: SURAASA_COLORS.yellow,

        // Custom
        lightCarbon: SURAASA_COLORS.lightCarbon,
        pearlGray: SURAASA_COLORS.pearlGray,
      },
    },
  },
})
